import AttestationDateDemande from '@/generated/controls/attestation/AttestationDateDemande.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AttestationDateDemande
})
